import AdminLayout from '../../templates/AdminLayout';
import Dashboard from '../../UI/organisms/etc/Dashboard';

const DashboardPage = () => {
  return <AdminLayout title={'대시보드'} content={<Dashboard />} sideType={0} />;
};

export default DashboardPage;
